import axios from 'axios'
import { useUserStore } from '../stores/user-store'
import router from '../router'

let axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

axiosInstance.interceptors.request.use((config) => {
  const currentLanguage = localStorage.getItem('user-locale') || 'kk'
  config.headers['X-Localization'] = currentLanguage
  const token = document.cookie.split('; ').find((row) => row.startsWith('XSRF-TOKEN='))

  if (token) {
    const tokenValue = decodeURIComponent(token.split('=')[1])
    config.headers['X-XSRF-TOKEN'] = tokenValue
  }

  return config
})

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const auth = useUserStore()
      auth.user = null

      if (router.currentRoute.value.meta.requiresAuth) {
        router.push('/auth/login')
      }
    }

    return Promise.reject(error)
  },
)

export default axiosInstance
